import { put, call, takeLatest, delay } from 'redux-saga/effects';
import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';

function* newsListGet(action) {
  const {res} = yield call(function(payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    return axios.post(config.apiUri + "member/newsListApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  if (res) {
    if (res.data.bool) {
      yield put({
        type: "NEWS_LIST_SET",
        payload: {
          list: res.data.list,
        },
      });
      action.callback(res.data);
    }
  }
}

function* newsReadEdit(action) {
  const {res} = yield call(function(payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('type', 'add');
    params.append('id', payload.id);
    return axios.post(config.apiUri + "member/newsReadEditApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  if (res) {
    if (res.data.bool) {
      yield put({
        type: "NEWS_ITEM_SET",
        payload: {
          type: 'read',
          id: action.payload.id,
        },
      });
      yield delay(600);
      yield put({type: 'NOTIFICATION_GET'});
    }
  }
}



const saga = [
  takeLatest('NEWS_LIST_GET', newsListGet),
  takeLatest('NEWS_READ_EDIT', newsReadEdit),
];

export default saga;
